import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Calendar } from "lucide-react";

const hostPath = `${window.location.protocol}//${window.location.hostname}`

export default function HomeEvents () {
    const [searchParams, setSearchParams] = useSearchParams();
    const eventsPath = `${hostPath}/events.php?loc=${searchParams.get("loc") ? searchParams.get("loc") : "events"}`
    const currentLoc = searchParams.get("loc")

    const currentTitle = currentLoc ? currentLoc.split("~")[currentLoc.split("~").length - 1] : ''
    const [events, setEvents] = useState([])

    useEffect(() => {
        fetch(eventsPath)
        .then(res => res.json())
        .then(data => {
            if (data) {
            setEvents([
                ...data.folders.map(folder => ({ id: folder.id, type: 'folder', title: folder.name, date: folder.date, src: folder.url, thumbnail: folder.thumb, orientation: 'landscape' })),
                // ...data.files.map(file => ({ id: file.id, type: file.type, src: file.url, orientation: file.orientation }))
            ]);
            }
        })

    }, [])

    const formatDate = (dateStr) => {
        // Parse parts of the date string
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);

        const date = new Date(`${year}-${month}-${day}`);

        return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        });
    };

    return (
        <>
        <div className="container py-5">
            <h2 className="about-title">Recent Events</h2>
            <div className="about-title-underline"></div>

            <div className="home_events__container">

            {events.reverse().map((event, index) => index < 3 && (
                <Link to={`${hostPath}/events/?${event.src.split('?')[1]}`}>
                <div
                    key={event.id}
                    className="home_events__item"
                >
                    {/* Event Image */}
                    <div className="home_events__item__img_container">
                        <img
                            src={`${hostPath}/${event.thumbnail}`}
                            alt={event.title}
                            className="w-full h-48 object-cover transition-transform duration-300"
                        />
                        {/* <div className="absolute top-4 left-4">
                            <Badge
                            className={`${getCategoryColor(event.category)} text-white border-0`}
                            >
                            {event.category}
                            </Badge>
                        </div> */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>

                    {/* Event Details */}
                    <div className="home_events__item__details">
                    <div>
                        {
                        event.title ? 
                        <h3 className="text-xl font-semibold mb-2 group-hover:text-primary transition-colors">
                            {event.title}
                        </h3>
                        : ""
                        }
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        <Calendar className="mr-2 h-4 w-4" />
                        {formatDate(event.date)}
                    </div>

                    {/* <Button
                        variant="ghost"
                        size="sm"
                        className="w-full group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
                    >
                        View Gallery
                        <ChevronRight className="ml-2 h-4 w-4" />
                    </Button> */}
                    </div>
                </div>
                </Link>
            ))}
            </div>

            {/* View All Events Button */}
            {/* <div className="text-center mt-12">
            <Button variant="outline" size="lg">
                View All Events & Photos
                <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
            </div> */}
        </div>

        {/* ---------------------------------------------------
          NEW CENTERED TITLE + CENTERED IMAGE BELOW SECTION
         --------------------------------------------------- */}
        <div
            className="about-bottom-wrapper"
            style={{
            textAlign: "center",
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
            }}
        >
            <h3
            style={{
                marginBottom: "15px",
                fontWeight: "600",
                fontSize: "20px"
            }}
            >
            Scan the QR code to download the files
            </h3>

            <img
            src="images/qr-school.jpeg"
            alt="Campus"
            style={{
                width: "100%",
                maxWidth: "200px",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                margin: "0 auto",
                display: "block",
                marginBottom: "40px"
            }}
            />
        </div>
        </>
    )
}